import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import sha256 from "js-sha256";
import i18n from "@/config/i18n";
import regular from "@/common/regular";
let PiMerchantResetPassword = class PiMerchantResetPassword extends Vue {
    constructor() {
        super(...arguments);
        this.formInline = {
            password: "",
            rePassword: "",
        };
        this.ruleInline = {
            password: [
                {
                    required: true,
                    validator: regular.password,
                    trigger: "blur",
                },
            ],
            rePassword: [
                {
                    required: true,
                    validator: regular.password,
                    trigger: "blur",
                },
                {
                    required: true,
                    trigger: "blur",
                    validator: (rule, value, callBack) => {
                        if (value !== this.formInline.password) {
                            callBack(new Error(i18n.t("userManage.confirmPasswordOldMsg") + ""));
                        }
                        else {
                            callBack();
                        }
                    },
                },
            ],
        };
    }
    handleSubmit() {
        this.$refs["formInline"]
            .validate((isValid) => {
            if (isValid) {
                const data = JSON.parse(JSON.stringify(this.formInline));
                data.password = sha256.sha256(data.password);
                this.$emit("resetPasswordData", data);
            }
        })
            .catch();
    }
    cancelhandleSubmit() {
        this.$emit("update:isShowResPassword", false);
    }
};
__decorate([
    Prop({ default: true })
], PiMerchantResetPassword.prototype, "isBtn", void 0);
__decorate([
    Prop({ default: 110 })
], PiMerchantResetPassword.prototype, "labelWidth", void 0);
PiMerchantResetPassword = __decorate([
    Component
], PiMerchantResetPassword);
export default PiMerchantResetPassword;
